// extracted by css-extract-rspack-plugin
export default {"link":"content-editor-plugin-link-Link-link-dcfe86c4"};